import { ImportantIcon } from "@/common/ImportantIcon";
import type { NotesTableRowData } from "../types/notes-table-types";
import type { NotesTableColumnGetter, NotesTableColumnsProps } from "../types";
import { NOTES_TABLE_COLUMNS_KEYS } from "../notes-table-columns-keys";

export type NotesTableImportantColumnProps = NotesTableColumnsProps;

export type NotesTableImportantColumnGetter =
  NotesTableColumnGetter<NotesTableImportantColumnProps>;

export const getNotesTableImportantColumn: NotesTableImportantColumnGetter = ({
  title = "",
  dataIndex = ["important"],
  width = 35,
  key = NOTES_TABLE_COLUMNS_KEYS.important,
  showSorterTooltip = false,
  sorter = (a: NotesTableRowData) => (a?.important ? 1 : -1),
  render = (_, record) => {
    return <ImportantIcon important={record.important ?? false} />;
  },
  ...props
}) => {
  return {
    title: title,
    dataIndex: dataIndex,
    width: width,
    key: key,
    sorter: sorter,
    render: render,
    showSorterTooltip: showSorterTooltip,
    ...props,
  };
};
